import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FILTER_VIEWS_KEY } from './constants';
import { createFilterView } from './filterViews';
import type {
  CreateFilterViewPayload,
  FilterView,
  FilterViewsResponse,
} from './filterViews.types';

/**
 * Hook to create a new filter view
 */
export const useCreateFilterView = (pageIdentifier: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateFilterViewPayload) =>
      createFilterView(pageIdentifier, data),
    onSuccess: (newView: FilterView) => {
      // Optimistically update the cache to prevent UI blink
      queryClient.setQueryData<FilterViewsResponse>(
        [FILTER_VIEWS_KEY, pageIdentifier],
        (oldData) => {
          if (!oldData) return [newView];
          return [...oldData, newView];
        },
      );
    },
  });
};
